module.exports = __webpack_public_path__ + "static/media/restart_gateway.54fe17ac.svg";